<template>
  <div>
    <mainone :mainonebread="mainonebread"></mainone>
    <maintwo :maintwoiconshow="maintwoiconshow" :maintwoforminfo="maintwoforminfo"
      :myinputoneisshow="maintwoforminfo.myinputoneisshow" :myinputone="maintwoforminfo.myinputone"
      :myselectleftisshow="maintwoforminfo.selectleftisshow" :myselectleft="maintwoforminfo.selectleft"
      :myselecttopisshow="maintwoforminfo.selecttopisshow" :myselecttop="maintwoforminfo.selecttop"
      :myinputishow="myinputishow" :myinput="myinput" :myinputonefullisshow="maintwoforminfo.myinputonefullisshow"
      :myinputonefull="maintwoforminfo.myinputonefull" :myselectisshow="myselectisshow" :myselect="myselect"
      :myselectuptopisshow="myselecttopisshow" :myselectuptop="myselecttop" :myselectcityisshow="myselectcityisshow"
      :myselectcity="myselectcity" v-on:getsearchinfo="getSeachinfoEvent" v-on:searchForm="searchFormEvent"></maintwo>
    <!--table表单-->
    <div>
      <!--主list列表-->
      <div class="box-list">
        <div style="line-height: 60px">
          <!--左侧名称-->
          <div style="float: left; font-size: 14px">数据列表</div>
          <!--右侧按钮-->
          <div style="float: right">
            <!--自定义按钮-点击出现弹框&点击跳转子类页面@click="routeraddrClick('/XX路由')"-->
            <!--1、点击出现弹框@click="addTanClick(XX弹框配置信息,dialogVisible = true);resetFormSenior(XXform表单)"-->
            <!--2、点击跳转子类页面@click="routeraddrClick('/XX路由')-->
            <!--<el-button ></el-button>-->
            <!--导出按钮-点击导出数据-->
            <el-button type="warning" plain @click="exportDatas()">导出</el-button>
          </div>
        </div>

        <div>
          <!--table表单-->
          <el-table :header-cell-style="{ background: '#F5F7FA' }" ref="multipleTable"
            :row-class-name="tableRowClassName" :data="
              mainthreetableData.slice(
                (currentPage - lastpage) * PageSize,
                currentPage * PageSize
              )
            " style="width: 100%" min-height="900" border v-loading="loading" element-loading-text="正在飞速加载中..."
            @selection-change="handleSelectionChange" @cell-click="handleOneData">
            <!--多选框-用于用户选择性导出数据-->
            <el-table-column type="selection" width="55" v-if="mainthreeisshowset" />
            <el-table-column v-for="(mytabletitle, i) in mainthreetabletitle" :key="i" :fixed="mytabletitle.fixedstatu"
              :prop="mytabletitle.prop" :label="mytabletitle.label" :width="mytabletitle.width">
              <!--这里先通过table列表中的title值进行判断，在进行渲染展示-->
              <!--例如：status状态字段，判断最终的值是那种表现形式等-->
              <template #default="scope" v-if="
                mytabletitle.prop === 'userinfo' ||
                mytabletitle.prop === 'price' ||
                mytabletitle.prop === 'agent_money' ||
                mytabletitle.prop === 'shop_money' ||
                mytabletitle.prop === 'agent_apply_type' ||
                mytabletitle.prop === 'shop_apply_type' ||
                mytabletitle.prop === 'addtime'
              ">
                <!-- 用户信息 -->
                <div v-if="mytabletitle.prop === 'userinfo'">
                  <div><span>用户ID：</span><span class="mytabletext" @click="routeraddrClick('/userlist', scope.row)">{{
                      scope.row.uid
                  }}</span></div>
                  <div><span>用户名：</span><span>{{ scope.row.nickname }}</span></div>
                  <div><span>手机号：</span><span>{{ scope.row.mobile }}</span></div>
                </div>
                <!-- 充值金额-->
                <div v-if="mytabletitle.prop === 'price'">
                  <div><span>{{ scope.row.price ? (scope.row.price / 100).toFixed(2) : '0.00' }}</span></div>
                </div>
                <!-- 代理商分佣金额-->
                <div v-if="mytabletitle.prop === 'agent_money'">
                  <div><span>{{ scope.row.agent_money ? (scope.row.agent_money / 100).toFixed(2) : '0.00' }}</span></div>
                </div>
                <!-- 商户分佣金额-->
                <div v-if="mytabletitle.prop === 'shop_money'">
                  <div><span>{{ scope.row.shop_money ? (scope.row.shop_money / 100).toFixed(2) : '0.00' }}</span></div>
                </div>
                <!-- 代理商结算方式 -->
                <div v-if="mytabletitle.prop === 'agent_apply_type'">
                  <div><span>{{ scope.row.agent_apply_type == 1 ? 'T+1 结算' : '定期结算' }}</span></div>
                </div>
                <!-- 商户结算方式 -->
                <div v-if="mytabletitle.prop === 'shop_apply_type'">
                  <div><span>{{ scope.row.shop_apply_type == 1 ? 'T+1 结算' : '定期结算' }}</span></div>
                </div>
                <!-- 交易时间 -->
                <div v-if="mytabletitle.prop === 'addtime'">
                  <div><span>{{ scope.row.addtime != 0 ? this.$utils.formatDate(scope.row.addtime) : '' }}</span></div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!--分页器-->
          <div class="block" style="text-align: center; margin: 30px 0">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="currentPage" :page-sizes="pageSizes" :page-size="PageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mainone from "@/components/Mainone";
import maintwo from "@/components/Maintwo";
// import { ElMessage } from "element-plus";
import axios from "axios";
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "vrechargememberaccount",
  inject: ["reload"], //刷新引用
  data() {
    return {
      mainonebread: [
        {
          name: "财务",
        },
        {
          name: "资金对账",
        },
        {
          name: "充值会员对账",
        },
      ], // 当前页-【面包屑导航】
      maintwoiconshow: true, // 筛选-【高级筛选按钮】
      maintwoforminfo: {
        myinputoneisshow: true, //筛选查询-左侧字+input
        myinputone: {
          divinterval: "0", //框右侧距离
          titlewidth: "74px", //标题宽度
          inputwidth: "200px", //input宽度
          inputinterval: "20px", //input右侧距离
          input: [
            {
              ismust: false, //是否必填，true表示必填
              title: "输入搜索：",
              placeholder: "充值订单ID/设备编号",
              name: "content",
              content: "",
            },
            {
              ismust: false, //是否必填，true表示必填
              title: "输入搜索：",
              placeholder: "代理商名称/商户名称",
              name: "shop_name",
              content: "",
            },
          ],
        },
        selectleftisshow: true, //筛选查询-左侧字+select单框||select时间
        selectleft: {
          width: "none",
          divinterval: "", //框右侧距离
          selectwidth: "200px",
          selectinterval: "20px", //select右侧距离
          select: [
            {
              selectisshow: true,
              ismust: false,
              title: "代理商结算方式：",
              placeholder: "全部",
              name: "agent_apply_type",
              value: "",
              options: [
                {
                  label: "全部",
                  value: "",
                },
                {
                  label: "T+1 结算",
                  value: "1",
                },
                {
                  label: "定期结算",
                  value: "2",
                },
              ],
            },
            {
              selectisshow: true,
              ismust: false,
              title: "商户结算方式：",
              placeholder: "全部",
              name: "shop_apply_type",
              value: "",
              options: [
                {
                  label: "全部",
                  value: "",
                },
                {
                  label: "T+1 结算",
                  value: "1",
                },
                {
                  label: "定期结算",
                  value: "2",
                },
              ],
            },
          ],
        },
      }, // 筛选-【筛选查询】-控件信息
      mainthreeisshowbut: false, // 数据列表中-【添加按钮】
      mainthreeisshowset: false, // 数据列表中-复选框
      mainthreeisshowope: false, // 数据列表中-操作-根据页面显示模块（整页）
      mainthreetableope: 9, // 数据列表中-操作-根据页面显示控件（整页）
      mainthreehandle: 150, // 数据列表中-操作-宽度
      mainthreetabletitle: [
        {
          fixedstatu: "left",
          prop: "trade_no",
          label: "充值订单ID",
          width: "250",
        },
        {
          fixedstatu: false,
          prop: "userinfo",
          label: "用户信息",
          width: "200",
        },
        {
          fixedstatu: false,
          prop: "client",
          label: "设备编号",
          width: "",
        },
        {
          fixedstatu: false,
          prop: "price",
          label: "充值金额",
          width: "",
        },
        {
          fixedstatu: false,
          prop: "agent_name",
          label: "代理商名称",
          width: "",
        },
        {
          fixedstatu: false,
          prop: "agent_money",
          label: "代理商分佣金额",
          width: "130",
        },
        {
          fixedstatu: false,
          prop: "agent_apply_type",
          label: "代理商结算方式",
          width: "130",
        },
        {
          fixedstatu: false,
          prop: "shop_name",
          label: "商户名称",
          width: "",
        },
        {
          fixedstatu: false,
          prop: "shop_money",
          label: "商户分佣金额",
          width: "130",
        },
        {
          fixedstatu: false,
          prop: "shop_apply_type",
          label: "商户结算方式",
          width: "130",
        },
        {
          fixedstatu: false,
          prop: "addtime",
          label: "交易时间",
          width: "180",
        },
      ], // 数据列表中-数据表头
      mainthreestatus: true, // 数据列表中-属于search按钮表示状态
      mainthreetableData: [], // 数据列表中-具体数据
      totalCount: 1, //数据列表中-数据总条数
      currentpage: 1, //数据列表中-数据当前页数
      lastpage: 1, //数据列表中-数据总页数（默认以20条一页）
      loading: false, //初始化-loading加载动效，默认是false关闭

      //高级筛选
      myinputishow: true, //高级筛选-input单框
      myinput: {
        divinterval: "3%", //框右侧距离
        inputwidth: "47%",
        inputmaxwidth: "100%",
        input: [
          {
            ismust: false, //是否必填，true表示必填
            title: "输入搜索：",
            placeholder: "充值订单ID/设备编号",
            name: "content",
            content: "",
          },
          {
            ismust: false, //是否必填，true表示必填
            title: "输入搜索：",
            placeholder: "代理商名称/商户名称",
            name: "shop_name",
            content: "",
          },
          {
            ismust: false, //是否必填，true表示必填
            title: "用户ID：",
            placeholder: "请输入用户ID",
            name: "uid",
            content: "",
          },
        ],
      },
      myselectisshow: true, //高级筛选-select单框
      myselect: {
        divinterval: "3%", //框右侧距离
        selectwidth: "47%",
        selectmaxwidth: "100%",
        select: [
          {
            selectisshow: true,
            ismust: false,
            title: "代理商结算方式：",
            placeholder: "全部",
            name: "agent_apply_type",
            value: "",
            options: [
              {
                label: "全部",
                value: "",
              },
              {
                label: "T+1 结算",
                value: "1",
              },
              {
                label: "定期结算",
                value: "2",
              },
            ],
          },
          {
            selectisshow: true,
            ismust: false,
            title: "商户结算方式：",
            placeholder: "全部",
            name: "shop_apply_type",
            value: "",
            options: [
              {
                label: "全部",
                value: "",
              },
              {
                label: "T+1 结算",
                value: "1",
              },
              {
                label: "定期结算",
                value: "2",
              },
            ],
          },
          {
            selecttimeduanisshow: true, //该字段表示时间段模块状态：且已写死（字段名不可修改!）
            ismust: false,
            title: "申请时间：",
            placeholder: {
              placeholderstart: "请选择开始时间",
              placeholderend: "请选择结束时间",
            },
            name: "addtime",
            value: {
              valuestart: ref(""),
              valueend: ref(""),
              endstatus: true,
            },
            rangeseparator: "至", //分隔符
            divinterval: "3%", //上方字中-框右侧距离
            selectwidth: "100%", //上方字中-总框长度
            selectmaxwidth: "97%", //时间段-最大宽度
            marginright: "0", //与右侧距离
          },
        ],
      },

      //table表单相关数据
      seniorform: {},
      currentPage: 1,
      pageSizes: [20, 50, 100],
      PageSize: 20,
      multipleSelection: [],
      thispagename: "", //通过路由获取当前页面的path值
      searchwidth: "580px",
      tancontent: {
        title: "弹框标题",
        content: {},
      }, //弹框

      mypowerlimits: JSON.parse(localStorage.getItem("powerlimits")), //获取权限
      mytoken: localStorage.getItem("token"), //获取存储的token
      pagesdatas: [], //存储最近一次的筛选条件，供分页使用
    };
  },
  mounted() {
    //获取当前页面路由path值
    this.thispagename = this.$route.path;
  },
  methods: {
    //table表中-当选项发生变化是触发该函数
    handleSelectionChange(val) {
      console.log("this is:" + val);
      this.multipleSelection = val;
    },
    //分页器中-当选择条数时触发该函数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.PageSize = val;
      this.currentPage = 1;

      //加载loading
      this.loading = true;
      //通过Ajax向后台获取数据
      axios
        .post(
          "/admin/printWallet/bill",
          {
            content: this.pagesdatas.content,
            shop_name: this.pagesdatas.shop_name,
            uid: this.pagesdatas.uid,
            agent_apply_type: this.pagesdatas.agent_apply_type,
            shop_apply_type: this.pagesdatas.shop_apply_type,
            addtime: this.pagesdatas.addtime,
            page: 1,
            page_size: val,
          },
          {
            headers: {
              Authentication: localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          this.myaxiosfunc(response.data.result);
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
    },
    //分页器中-当选择分页时触发该函数
    handleCurrentChange(val) {
      console.log(`当前页: 第${val}页`);
      this.currentPage = val;

      //加载loading
      this.loading = true;
      //通过Ajax向后台获取数据
      axios
        .post(
          "/admin/printWallet/bill",
          {
            content: this.pagesdatas.content,
            shop_name: this.pagesdatas.shop_name,
            uid: this.pagesdatas.uid,
            agent_apply_type: this.pagesdatas.agent_apply_type,
            shop_apply_type: this.pagesdatas.shop_apply_type,
            addtime: this.pagesdatas.addtime,
            page: val,
            page_size: this.PageSize,
          },
          {
            headers: {
              Authentication: localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          this.myaxiosfunc(response.data.result);
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
    },
    //点击进行路由页面跳转以及携带参数
    routeraddrClick(routeraddr, rowdata) {
      if (rowdata) {
        // 跳转-用户列表
        if (routeraddr == "/userlist") {
          this.$router
            .push({ path: routeraddr, query: { userid: rowdata.uid } })
            .catch((error) => error);
        }
      } else {
        this.$router.push(routeraddr).catch((error) => error);
      }
    },
    //导出数据
    exportDatas() {
      axios
        .post(
          "/admin/printWallet/bill",
          {
            content: this.pagesdatas.content,
            shop_name: this.pagesdatas.shop_name,
            uid: this.pagesdatas.uid,
            agent_apply_type: this.pagesdatas.agent_apply_type,
            shop_apply_type: this.pagesdatas.shop_apply_type,
            addtime: this.pagesdatas.addtime,
            export: 1,
          },
          {
            headers: {
              Authentication: localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data.message)
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
    },

    //提交等相关event事件函数
    //获取Container-Pagedata-Maintwo-高级筛选-开始检索返回的数据
    searchFormEvent(data) {
      // console.log("高级筛选-开始检索返回数据(页面):" + JSON.stringify(data));
      this.pagesdatas = data; //将筛选条件赋值给本页的pagesdatas存储，供分页使用
      //判断-转账时间段状态
      var getaddtime = null;
      if (data.addtime.start == "") {
        getaddtime = "";
      } else {
        if (data.addtime.end == "") {
          getaddtime =
            data.addtime.start + " ~ " + (data.addtime.start + 86400 - 1);
        } else {
          getaddtime =
            data.addtime.start + " ~ " + (data.addtime.end + 86400 - 1);
        }
      }
      this.pagesdatas.addtime = getaddtime;
      //加载loading
      this.loading = true;
      //通过Ajax向后台获取数据
      axios
        .post(
          "/admin/printWallet/bill",
          {
            content: data.content,
            shop_name: data.shop_name,
            uid: data.uid,
            agent_apply_type: data.agent_apply_type,
            shop_apply_type: data.shop_apply_type,
            addtime: getaddtime,
            page: 1,
            page_size: this.PageSize,
          },
          {
            headers: {
              Authentication: localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          this.myaxiosfunc(response.data.result);
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
    },
    //获取Container-Pagedata-Maintwo-搜索-返回的数据
    getSeachinfoEvent(data) {
      // console.log("点击查询获取的data数组：" + JSON.stringify(data));
      this.pagesdatas = data; //将筛选条件赋值给本页的pagesdatas存储，供分页使用
      //加载loading
      this.loading = true;
      //通过Ajax向后台获取数据
      axios
        .post(
          "/admin/printWallet/bill",
          {
            content: data.content,
            shop_name: data.shop_name,
            agent_apply_type: data.agent_apply_type,
            shop_apply_type: data.shop_apply_type,
            page: 1,
            page_size: this.PageSize,
          },
          {
            headers: {
              Authentication: localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          this.myaxiosfunc(response.data.result);
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
    },
    //数据渲染
    myaxiosfunc(successdata) {
      var newdata = successdata.data;
      this.mainthreetableData = newdata;
      this.totalCount = successdata.total;
      this.currentpage = successdata.current_page; //当前页面页数
      this.lastpage = successdata.last_page;
      this.loading = false;
    },
  },
  created() {
    if (localStorage.getItem("token") === null || !localStorage.getItem("token")) {
      this.isshow = false;
      this.$router.push("/").catch((error) => error);
    } else {
      //加载loading
      this.loading = true; //通过Ajax向后台获取数据
      //通过Ajax向后台获取数据
      axios
        .post(
          "/admin/printWallet/bill",
          {
            page: 1,
            page_size: this.PageSize,
          },
          {
            headers: {
              Authentication: localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          this.myaxiosfunc(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  },
  components: {
    mainone,
    maintwo,
  },
});
</script>

<style scoped>
/*操作中-按钮样式*/
.el-button--mini {
  min-height: 28px;
  padding: 0 8px;
  font-size: 12px;
  border-radius: calc(var(--el-border-radius-base) - 1px);
}

.mytabletext {
  color: var(--el-color-primary);
  cursor: pointer;
}

.box-list {
  margin-top: 10px;
  background-color: #ffffff;
  border-radius: 4px;
  line-height: 40px;
  padding: 0 20px;
}
</style>